import { toSafeDate } from './toSafeDate'

/**
 * Форматирует дату в формат "день месяц" (например, "27 сентября")
 */
export function formatDayMonth (date: Date | string | number | null | undefined): string {
  const d = toSafeDate(date)
  if (!d) return ''
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' })
}
